import { DocumentSummaryModel } from '../../cmg-1003/models';
import { ILoanStatusCard, LoanStatusCardConfig, LoanStatusCardType } from './loan-status-card.model';

export const GetDocsStatus = (documentSummary: DocumentSummaryModel): ILoanStatusCard => {
  const cardBase = LoanStatusCardConfig.find((c) => c.cardType === LoanStatusCardType.Docs);
  const card = <ILoanStatusCard>{ ...cardBase, cardType: LoanStatusCardType.Docs };
  const noDocsClass = 'no-docs';
  const waitingToolTip = `${documentSummary?.numWaiting ?? 0} ${documentSummary?.numWaiting !== 1 ? 'Docs' : 'Doc'} requested`;
  const needsReviewToolTip = `${documentSummary?.numNeedsReview ?? 0} ${documentSummary?.numNeedsReview !== 1 ? 'Docs' : 'Doc'} ready for review`;
  const reviewedToolTip = `${documentSummary?.numReviewed ?? 0} ${documentSummary?.numReviewed !== 1 ? 'Docs' : 'Doc'} processed`;

  card.descriptionHtml = `
  <div class="document-summary">
    <div class="waiting ${documentSummary?.numWaiting > 0 ? '' : noDocsClass}" title="${waitingToolTip}"><span>${documentSummary?.numWaiting ?? 0}</span></div>
    <div class="needs-review ${documentSummary?.numNeedsReview > 0 ? '' : noDocsClass}" title="${needsReviewToolTip}"><span>${documentSummary?.numNeedsReview ?? 0}</span></div>
    <div class="reviewed ${documentSummary?.numReviewed > 0 ? '' : noDocsClass}" title="${reviewedToolTip}"><span>${documentSummary?.numReviewed ?? 0}</span></div>
  </div>`;
  return card;
};
